import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MenuModule } from 'primeng/menu';
import { ApartmentsModule } from '../../apartments/apartments.module';
import { AuthModule } from '../../auth/auth.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessagesModule } from '../../ui-components/messages/messages-module';



@NgModule({
  declarations: [
    HeaderComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    MenuModule,
    ApartmentsModule,
    AuthModule,
    MessagesModule,
    ConfirmDialogModule
  ],
  exports: [
    HeaderComponent
  ]
})
export class HeaderModule { }
